import React from 'react';
import Modal from './ModalConversion';
import FileUploader from './FileUploader';
import { endpointUploadAdminCover, urlConversion } from '../services/Endpoints';

export const PortadasModal = ({ isOpen, onClose, project, onSuccess }) => {
    if (!project) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="p-2">
                <h3 className="mb-4 text-white">Subir Portada</h3>
                
                <div className="mb-4 p-3 bg-dark rounded border border-secondary text-white">
                    <div className="row align-items-center">
                        <div className="col">
                            <p className="text-white-50 small mb-1 text-uppercase fw-bold">Proyecto</p>
                            <p className="m-0 h5">{project.account}-C-{project.ink_id}</p>
                        </div>
                        <div className="col-auto text-end">
                            <p className="text-white-50 small mb-1 text-uppercase fw-bold">Título</p>
                            <p className="m-0 text-truncate" style={{ maxWidth: '200px' }}>{project.title}</p>
                        </div>
                    </div>
                </div>
                
                <div className="mt-2 text-center text-white">
                    <FileUploader 
                        account={project.account} 
                        ink_id={project.ink_id} 
                        onSuccess={onSuccess}
                        accept=".png,.jpg,.jpeg"
                        uploadUrl={`${urlConversion}${endpointUploadAdminCover}`}
                        label="Subir portada"
                        fileTypeLabel="imagen (PNG o JPG)"
                        helpText="Formatos permitidos: .png, .jpg, .jpeg"
                    />
                </div>

                <div className="d-flex justify-content-end mt-4 pt-3 border-top border-secondary">
                    <button type="button" className="btn btn-outline-secondary px-4 h6 mb-0" onClick={onClose}>Cerrar</button>
                </div>
            </div>
        </Modal>
    );
};

export default PortadasModal;
